var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-rank-setter_rule" },
    [
      _c(
        "yxt-form",
        {
          ref: "rankForm",
          attrs: {
            model: _vm.rankForm,
            rules: _vm.rules,
            enableDetectFieldsChange: _vm.isInitialFinished,
            "label-position": "top",
          },
        },
        [
          _c(
            "yxt-form-item",
            {
              staticClass: "yxtbiz-rank-setter_rule_select_item",
              attrs: {
                label: _vm.$t("pc_biz_rank_dimension").d("排行维度"),
                prop: "dimensionCode",
              },
            },
            [
              _c(
                "yxt-select",
                {
                  staticClass: "mt8 yxtbiz-rank-setter_rule_select",
                  attrs: {
                    size: "small",
                    placeholder: _vm
                      .$t("pc_biz_rank_dimension_tip")
                      .d("请选择排行维度"),
                  },
                  on: { change: _vm.onConfigChange },
                  model: {
                    value: _vm.rankForm.dimensionCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.rankForm, "dimensionCode", $$v)
                    },
                    expression: "rankForm.dimensionCode",
                  },
                },
                _vm._l(_vm.dimensionList, function (item) {
                  return _c("yxt-option", {
                    key: item.key,
                    attrs: {
                      label: _vm.$t(item.label).d(item.text),
                      value: item.key,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            {
              staticClass: "mb15",
              attrs: {
                prop: "dateType",
                label: _vm.$t("pc_biz_rank_cycle").d("排行周期"),
              },
            },
            [
              _c(
                "yxt-checkbox-group",
                {
                  staticClass: "yxtbiz-rank-setter_rule_cycle",
                  model: {
                    value: _vm.rankForm.dateType,
                    callback: function ($$v) {
                      _vm.$set(_vm.rankForm, "dateType", $$v)
                    },
                    expression: "rankForm.dateType",
                  },
                },
                _vm._l(_vm.dateList, function (item) {
                  return _c(
                    "yxt-checkbox",
                    { key: item.type, attrs: { label: item.type } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(item.label).d(item.text)) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            {
              staticClass: "yxtbiz-rank-setter_rule_select_item",
              attrs: { prop: "objectCode" },
            },
            [
              _c(
                "div",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("pc_biz_rank_participate_object").d("参与对象")
                      ) +
                      "\n        "
                  ),
                  _c("span", { staticClass: "yxt-form-item__required mr2" }, [
                    _c("i", { staticClass: "required-dot" }),
                  ]),
                  _c(
                    "yxt-tooltip",
                    {
                      attrs: {
                        placement: "right",
                        content: _vm
                          .$t("pc_biz_rank_participate_object_prompt")
                          .d(
                            "员工榜单实时更新，部门人均榜单和部门总计榜单隔天更新"
                          ),
                      },
                    },
                    [
                      _c("yxt-svg", {
                        staticClass: "color-gray-6 hover-primary-6",
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "icon-class": "icons/question-cirlce-o",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "yxt-select",
                {
                  staticClass: "mt8 yxtbiz-rank-setter_rule_select",
                  attrs: {
                    size: "small",
                    placeholder: _vm
                      .$t("pc_biz_rank_participate_object_tip")
                      .d("请选择参与对象"),
                  },
                  on: { change: _vm.onConfigChange },
                  model: {
                    value: _vm.rankForm.objectCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.rankForm, "objectCode", $$v)
                    },
                    expression: "rankForm.objectCode",
                  },
                },
                _vm._l(_vm.objectList, function (item) {
                  return _c("yxt-option", {
                    key: item.key,
                    attrs: {
                      label: _vm.$t(item.label).d(item.text),
                      value: item.key,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.rankForm.objectCode === "user"
            ? _c(
                "div",
                { staticClass: "yxtbiz-rank-setter_rule_user_scope_box mb24" },
                [
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "yxtbiz-rank-setter_rule_select_item",
                      attrs: { prop: "userScope" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex yxtbiz-rank-setter_rule_user_scope",
                          attrs: { slot: "label" },
                          slot: "label",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("pc_biz_rank_object_scope").d("对象范围")
                              )
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "yxt-form-item__required" },
                            [_c("i", { staticClass: "required-dot" })]
                          ),
                          _c(
                            "yxt-popover",
                            {
                              attrs: { placement: "top-start" },
                              on: { "after-leave": _vm.onUserScopeChange },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "yxtbiz-rank-setter_rule_user_scope_tip",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "standard-size-16 yxtf-weight-6 mb8",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.rangeList[_vm.tipIndex].label
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "standard-size-12 text-8c" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm
                                              .$t("pc_biz_rank_sketch_map")
                                              .d("示意图")
                                          ) +
                                          "（" +
                                          _vm._s(_vm.tipIndex + 1) +
                                          "/" +
                                          _vm._s(_vm.rangeList.length) +
                                          "）\n              "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "yxtbiz-rank-setter_rule_user_scope_tip_img",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "yxtbiz-rank-setter_rule_arrow",
                                          on: {
                                            click: function ($event) {
                                              return _vm.switchTip("prev")
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "yxt-icon-arrow-left",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        [
                                          _c("yxt-image", {
                                            attrs: {
                                              width: "208px",
                                              height: "152px",
                                              src:
                                                _vm.$staticBaseUrl +
                                                "ufd/55a3e0/ssp/pc/img/user_scope" +
                                                _vm.rangeList[_vm.tipIndex]
                                                  .type +
                                                ".png",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "yxtbiz-rank-setter_rule_arrow",
                                          on: {
                                            click: function ($event) {
                                              return _vm.switchTip("next")
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "yxt-icon-arrow-right",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "yxtbiz-rank-setter_rule_icon_area standard-size-12 text-8c",
                                    },
                                    [
                                      _c("yxt-image", {
                                        staticClass: "mr4",
                                        attrs: {
                                          width: "12px",
                                          height: "12px",
                                          src:
                                            _vm.$staticBaseUrl +
                                            "ufd/55a3e0/ssp/pc/img/scope_position.png",
                                        },
                                      }),
                                      _vm._v(
                                        "\n\n                " +
                                          _vm._s(
                                            _vm
                                              .$t("pc_biz_rank_belong_dept")
                                              .d("所属部门")
                                          ) +
                                          "\n\n                "
                                      ),
                                      _c("yxt-image", {
                                        staticClass: "mr4 ml24",
                                        attrs: {
                                          width: "12px",
                                          height: "12px",
                                          src:
                                            _vm.$staticBaseUrl +
                                            "ufd/55a3e0/ssp/pc/img/scope_check.png",
                                        },
                                      }),
                                      _vm._v(
                                        "\n\n                " +
                                          _vm._s(
                                            _vm
                                              .$t(
                                                "pc_biz_rank_statistical_range"
                                              )
                                              .d("统计范围")
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "yxt-button",
                                {
                                  staticClass: "font-size-12 ml8",
                                  attrs: { slot: "reference", type: "text" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .$t("pc_biz_rank_view_example")
                                        .d("查看示例")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "yxt-select",
                        {
                          staticClass: "mt8 yxtbiz-rank-setter_rule_select",
                          attrs: {
                            size: "small",
                            placeholder: _vm
                              .$t("pc_biz_rank_object_scope_tip")
                              .d("请选择对象范围"),
                          },
                          on: { change: _vm.onUserScopeChange },
                          model: {
                            value: _vm.rankForm.userScope,
                            callback: function ($$v) {
                              _vm.$set(_vm.rankForm, "userScope", $$v)
                            },
                            expression: "rankForm.userScope",
                          },
                        },
                        _vm._l(_vm.rangeList, function (item) {
                          return _c("yxt-option", {
                            key: item.type,
                            attrs: {
                              label: _vm.$t(item.label).d(item.text),
                              value: item.type,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.module === "xuanxing"
                    ? _c(
                        "yxt-form-item",
                        {
                          staticClass:
                            "yxtbiz-rank-setter_rule_select_item yxtbiz-rank-setter_rule_excludeUser",
                          attrs: { prop: "excludeUser" },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c(
                                "yxt-checkbox",
                                {
                                  staticStyle: { "align-items": "normal" },
                                  on: { change: _vm.addExcludeUserChange },
                                  model: {
                                    value: _vm.addExcludeUser,
                                    callback: function ($$v) {
                                      _vm.addExcludeUser = $$v
                                    },
                                    expression: "addExcludeUser",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm
                                          .$t("pc_biz_rank_add_exclude_person")
                                          .d("添加排除人员")
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("yxt-select", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.addExcludeUser,
                                expression: "addExcludeUser",
                              },
                            ],
                            staticClass:
                              "mt8 ml24 yxtbiz-rank-setter_rule_select_user",
                            attrs: {
                              size: "small",
                              multiple: "",
                              placeholder: _vm
                                .$t("pc_biz_lbl_selecttip")
                                .d("请选择"),
                              "icon-name": "more",
                              "hidden-option": "",
                              "collapse-tags": "",
                              "value-key": "id",
                              "prop-label": "fullname",
                            },
                            on: {
                              "visible-change": function ($event) {
                                return _vm.showSelecter("persons")
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "tag",
                                  fn: function (ref) {
                                    var data = ref.data
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(data.currentLabel)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2668518610
                            ),
                            model: {
                              value: _vm.rankForm.excludeUser,
                              callback: function ($$v) {
                                _vm.$set(_vm.rankForm, "excludeUser", $$v)
                              },
                              expression: "rankForm.excludeUser",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "yxt-form-item",
                {
                  staticClass:
                    "yxtbiz-rank-setter_rule_dept_scope_box yxtbiz-rank-setter_rule_select_item",
                  attrs: { prop: "deptScope" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex yxtbiz-rank-setter_rule_user_scope",
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pc_biz_rank_object_scope").d("对象范围")
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "yxt-form-item__required" }, [
                        _c("i", { staticClass: "required-dot" }),
                      ]),
                      _c(
                        "span",
                        { staticClass: "text-8c standard-size-12 ml8" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("pc_biz_rank_dept_limit").d("可选3-50个")
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("yxt-select", {
                    staticClass: "mt8 yxtbiz-rank-setter_rule_select_user",
                    attrs: {
                      size: "small",
                      multiple: "",
                      placeholder: _vm.$t("pc_biz_lbl_selecttip").d("请选择"),
                      "icon-name": "more",
                      "hidden-option": "",
                      "collapse-tags": "",
                      "value-key": "id",
                      "prop-label": "name",
                    },
                    on: {
                      "visible-change": function ($event) {
                        return _vm.showSelecter("department")
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "tag",
                        fn: function (ref) {
                          var data = ref.data
                          return [
                            _c("span", [_vm._v(_vm._s(data.currentLabel))]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.rankForm.deptScope,
                      callback: function ($$v) {
                        _vm.$set(_vm.rankForm, "deptScope", $$v)
                      },
                      expression: "rankForm.deptScope",
                    },
                  }),
                ],
                1
              ),
          _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_rank_more_config").d("更多配置"),
                prop: "minScopeOpen",
              },
            },
            [
              _c(
                "yxt-checkbox",
                {
                  attrs: { "true-label": 1, "false-label": 0 },
                  model: {
                    value: _vm.rankForm.minScopeOpen,
                    callback: function ($$v) {
                      _vm.$set(_vm.rankForm, "minScopeOpen", $$v)
                    },
                    expression: "rankForm.minScopeOpen",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(_vm.configName.label).d(_vm.configName.text)
                      ) +
                      "\n        "
                  ),
                  _c("yxt-input-number", {
                    staticClass: "mh8 yxtbiz-rank-setter_rule_input_number",
                    attrs: { size: "small", precision: 0, min: 0, max: 9999 },
                    on: { blur: _vm.onScopeValueBlur },
                    model: {
                      value: _vm.rankForm.minScopeValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.rankForm, "minScopeValue", $$v)
                      },
                      expression: "rankForm.minScopeValue",
                    },
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_biz_rank_no_rank").d("不参与排名")) +
                      "\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            "destroy-on-close": "",
            size: "960px",
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm.selectorTitle.length > 1
              ? _c(
                  "span",
                  { staticClass: "standard-size-12 text-59" },
                  _vm._l(_vm.selectorTitle, function (item, index) {
                    return _c(
                      "span",
                      {
                        key: index,
                        class: {
                          "text-8c hand":
                            index !== _vm.selectorTitle.length - 1,
                          "yxtf-weight-6":
                            index === _vm.selectorTitle.length - 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickTitle(index)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              "hover-primary-6":
                                index !== _vm.selectorTitle.length - 1,
                            },
                          },
                          [_vm._v("\n            " + _vm._s(item))]
                        ),
                        index !== _vm.selectorTitle.length - 1
                          ? _c("span", { staticClass: "ml4 mr4" }, [
                              _c("i", { staticClass: "yxt-icon-arrow-right" }),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _c("span", [_vm._v(_vm._s(_vm.selectorTitle[0]))]),
          ]),
          _c("YxtbizRangeSelector", {
            ref: "rangeSelector",
            attrs: {
              selected: _vm.selectData,
              tabs: _vm.tabs,
              limit: _vm.limit,
              dataPermissionCode: _vm.dataPermissionCode,
              functionCode: _vm.functionCode,
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("pc_biz_common_cancel_mini"))
                  ),
                ]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.getRangeSelector },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_common_btn_sure")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }